<template>
  <div class="col95 glassModulo" style="background:white;color:black;">
    
    <div class="block tCenter" style="width:100%;line-height:40px;margin-top:30px;">
      
      <div class="col95 tCenter" style="margin:0 auto;min-height: 20px;">

        <h2 class="center" style="font-family: town;color:var(--orange);"  v-if="userStore.carritoCursos.length==0">
          <strong style="text-shadow: 4px 4x 14px rgba(31,38,135,0.8);">
            Verificación de Correo
          </strong>
        </h2>

      </div>

      <div class="formRow col90 center" style="margin-top:10px;">

        <div>

          <div class="tCenter tLeft col90 center">

            <label style="text-align:left;">
              Para asegurar el correcto seguimiento de su cuenta debe de verificar su dirección correo electrónico.
            </label>
            
          </div>

          <div class="tLeft col90 center" style="margin-top:30px;margin-bottom: 30px;">
            Dirección de Correo Electrónico:
            <strong>
              {{userStore.correo}}
            </strong>
          </div>

          <div style="margin-bottom: 30px;">
            <button class="btnBlue col90" @click="sendCorreoVerificacion()">
              <i class="bi bi-envelope-plus-fill"></i>
              Enviar Mensaje de Verificación a {{ userStore.correo }}
            </button>

            <button class="btnOrange col45 row">
              <i class="bi bi-envelope-x-fill"></i>
              Mi Dirección de Correo es incorrecta
            </button>

            <button class="btnError col45 row" @click="closeAccion()">
              <i class="bi bi-x-lg"></i>
              Cancelar Verificación de Correo
            </button>

          </div>

        </div>
        
        
      </div>

    </div>
    
    
    
    <modal title="Verificar Correo Electrónico" v-if="showModal" v-on:closeModalEv="closeModal()" style="display:block;left:10vw;top:0vh;height:28vh;max-height:30vh;">
      <div style="text-align:center;overflow-y:auto;">
        <h3 style="color:black;">
          {{modalMessage}}
        </h3>
      </div>
      <div class="fullWidth" v-if="envioExitoso">

        <div class="col95 center tCenter">
          <p>
              
            <strong>
              {{correoEnviadoA}}
            </strong>
          </p>
          <p>
            <label>
              Busca el mensaje de verificación enviado a tu bandeja de correo electrónico y haz click en el botón "Verificar Dirección de Correo Electrónico".
            </label>
          </p>
          <p>
            <strong>
              En caso de no encontrarse en tu bandeja principal, es posible que se encuentre en la bandeja de "Correo no deseado" o "SPAM".
            </strong>
          </p>
        </div>

      </div>

    </modal>

  </div>
</template>

<script>

import { mapStores } from 'pinia';
import { useUserStore } from '../../../store/user';

import Modal from '../../Modal/Modal.vue';


export default {
  name: 'VerificacionCorreo',
  components:{
    Modal,
    //InputText    
  },
  mounted:function(){

    
    

  },
  data:function(){
    return{

      correoEnviadoA:'',
      envioExitoso:false,
      showVals:false,
      showYaTengoCuenta:false,
      showModal:false,
      
      modalMessage:'',
      
      formData:{        
        'correo':{data:"",state:0},
      },
    };    
  },
  methods:{

    closeAccion(){

      this.$emit('closeAccionEv');

    },

    closeModal(){
      this.showModal = false;      
    },
    
    sendCorreoVerificacion(){
      console.log("sendCorreoVerificacion()");
      this.envioExitoso = false;
      this.correoEnviadoA = '';
      
      let data = {
        idAl:''+this.userStore.idAlCur,
        eVal:''+"UNSET"
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateSendCorreo/",
        data,
        this.onSuccessSendRegistrarCursos
      );
    },
    onSuccessSendRegistrarCursos(data){
      console.log("onSuccessSendRegistrarCursos:");
      console.log(data);
      if(data.sent=='sent'){
        this.showModal=true;      
        this.correoEnviadoA  = '' + data.correo;
        this.modalMessage = 
        'Mensaje de verificación enviado exitosamente a: ';        
        this.envioExitoso = true;
        
      }else{
        this.showModal=true;
        this.modalMessage='Error al enviar el mensaje de verificación, por favor intentalo nuevamente mas tarde, en caso de continuar con el error por favor pongase en contacto con el personal administrativo del plantel para mayor información';
        console.log(data.sent);
      }
      //this.$root.importData(data);      
    },

  },
  computed:{
    ...mapStores(useUserStore),
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.glassModulo{
    
    z-index:100;  
    
    background: rgba(255,255,255,0.30);    
    backdrop-filter: blur(2px);
    box-shadow: 0 10px 32px 0 rgba(31,38,135,0.37);    
    margin: 0 auto;
    margin-bottom: 0px;
    border-radius: 10px;
    padding:5px;
    border: 1px solid rgba(255,255,255,0.18);
    
  }

</style>
